import type { Role } from '@prisma/client'

export default function hasTrialProRole(roles: Role[]) {
  return roles.some((role) => isTrialProRole(role))
}

export function isTrialProRole(role: Role) {
  return ['Sponsor', 'ResearchCoordinator'].includes(role)
}
